import { auth } from "@api/auth/path";
import { availablePlanYears } from "@api/availablePlanYears/path";
import { files } from "@api/files/path";
import { filters } from "@api/filters/path";
import { geo } from "@api/geo/path";
import { installments } from "@api/installments/path";
import { measurementUnitKinds } from "@api/measurementUnitKinds/path";
import { orderings } from "@api/orderings/path";
import { planKinds } from "@api/planKinds/path";
import { productPlans } from "@api/productPlans/path";
import { selectTypes } from "@api/selectTypes/path";
import { generalStats } from "@api/stats/path";
import { stores } from "@api/stores/path";
import { subscriptions } from "@api/subscriptions/path";
import { test } from "@api/test/path";
import { users } from "@api/users/path";

export const path = {
  users,
  files,
  geo,
  auth,
  selectTypes,
  filters,
  test,
  generalStats,
  productPlans,
  availablePlanYears,
  stores,
  subscriptions,
  installments,
  planKinds,
  orderings,
  measurementUnitKinds,
};
